import { Typography } from '@/shared/ui/atoms';

const SolutionMobileSubTitle = () => {
  return (
    <div className="pt-6 pb-[30px] px-5">
      <Typography className="text-black text-[28px] font-bold leading-[130%] tracking-[-0.56px]">최고의 파트너들과 함께합니다.</Typography>
      <Typography className="mt-4 text-[#383A4D] text-[15px] font-medium leading-[145%] tracking-[-0.075px]">다양한 진료과 병원에서 리뷰웍스를 이용하고 있습니다.</Typography>
    </div>
  );
};

export default SolutionMobileSubTitle;
